import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

import IloomReviewsPageWidget from "./IloomReviewsPageWidget";

class ReviewsPageWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly moi: MutationObserverInjector
    ) {}

    start() {
        this.logger.debug(`${ReviewsPageWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger.debug(
                `${ReviewsPageWidgetInjector.name} found placeholder`,
                placeholder
            );

            const widget = new IloomReviewsPageWidget(
                {
                    target: placeholder,
                },
                this.logger
            );

            void widget.init();
        });
    }
}

export default ReviewsPageWidgetInjector;
